import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BootstrapDialogAction } from '../../bootstrap-dialog-action';
import { BootstrapDialogFrame } from '../frame/bootstrap-dialog.frame';

export interface BootstrapMessageDialogData { message: string, buttonText?: string, bullets?: string[] }


@Component({
	selector: 'message-dialog',
	standalone: true,
	imports: [BootstrapDialogFrame, CommonModule],
	templateUrl: './bootstrap-message.dialog.html'
})

export class BootstrapMessageDialog {

	activeModal = inject(NgbActiveModal);

	public readonly data = input<BootstrapMessageDialogData>({ message: '', bullets: [] });


	public actions = computed<BootstrapDialogAction[]>(() => {
		return [
			{
				id: 'okay',
				enabled: true,
				visible: true,
				label: this.data().buttonText ?? 'Okay',
				cssClass: 'btn-standard',
				linkType: "no-action",
				willCloseDialog: true,
			}
		];
	});


}
